window.initInfiniteScroll = function(){
  $(window).scroll(function() {
    if (!$('#infinite-content').length) { return };
    let current_page = $('#infinite-content').attr('data-current-page');
    let total_pages = $('#infinite-content').attr('data-total-pages');
    let url = $('#infinite-content').attr('data-load-content-url');
    if(!(parseInt(current_page) >= parseInt(total_pages))){
      if(!$('#infinite-content').hasClass("is-loading")){
        if($(window).scrollTop() + $(window).height() > $(document).height() - 300) {
          $('#infinite-content').addClass("is-loading");
          $.ajax({
            method: "GET",
            url: `${url}&page=${parseInt(current_page) + 1}`,
            dataType: "script"
          })
        }
      }
    }
  });
}